
























import { Component, Prop, Vue } from "vue-property-decorator";
import { IShopListItem } from "@/models/shop";
import { ShopItemsLayout } from "@/data/shop/enums";
import _ from "@/boot/lodash";

@Component({
  components: {
    "shop-product-list-item": () =>
      import(
        "@/components/app/global/baskets/basket/shop/shopProductListItem.vue"
      )
  }
})
export default class ShopProductsVerticalList extends Vue {
  // Props
  @Prop({ required: true })
  public hasMore!: boolean;

  @Prop({ default: () => [] })
  public items!: IShopListItem[];

  @Prop({ required: true })
  public isLoading!: boolean;

  @Prop({ required: true })
  public isLoadingMore!: boolean;

  @Prop({ default: false })
  public isDisabled!: boolean;

  @Prop({ default: false })
  public showHorizontal!: boolean;

  @Prop({
    default: ShopItemsLayout.VERTICAL,
    validator: val => _.values(ShopItemsLayout).includes(val)
  })
  public layout!: ShopItemsLayout;

  // Data
  public isProcessing: object = {};

  public get truncateLength() {
    if (this.layout === ShopItemsLayout.HORIZONTAL) return 100;
    return 80;
  }
}
